import { render, staticRenderFns } from "./recordTextEle.vue?vue&type=template&id=134e330b&scoped=true&"
import script from "./recordTextEle.vue?vue&type=script&lang=js&"
export * from "./recordTextEle.vue?vue&type=script&lang=js&"
import style0 from "./recordTextEle.vue?vue&type=style&index=0&id=134e330b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134e330b",
  null
  
)

export default component.exports